import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreoAnimations } from '@treo/animations';
import { parseCurrencyValue } from '../utils/currency-parser';

@Component({
  selector: 'ew-currency-money',
  templateUrl: './currency-money.component.html',
  styleUrls: ['./currency-money.component.scss'],
  animations: TreoAnimations,
})
export class CurrencyMoneyComponent {
  @Input() item: any;
  @Input() selected: boolean = false;
  @Input() dollarConversion: boolean = false;
  @Input() showIncomeBalance: boolean = true;
  @Input() showRadioButton: boolean = false;
  @Input() hideNullBalance: boolean = false;
  @Output() valueSelected = new EventEmitter<string>();

  today = new Date();

  constructor() {}

  /**
   * Parses the last transaction value to a number, handling different decimal and thousand separators.
   * @returns The parsed number or null if the input is invalid.
   */
  get lastTransactionValue(): number | null {
    return parseCurrencyValue(this.item.lastTransaction);
  }

  getParsedLastTransaction(value: string | number): number | null {
    return parseCurrencyValue(value);
  }

  getParsedBalance(value: string | number): number | null {
    return parseCurrencyValue(value);
  }
}
